<nav class="breadcrumb" [attr.aria-label]="'common.breadcrumbLabel' | translate">
  <ol class="breadcrumb__list">
    @for (item of items; track item.key; let last = $last) {
      <li class="breadcrumb__item">
        @if (!last) {
          <a class="breadcrumb__link" [routerLink]="item.key | localizedLink: item.params">
            {{ item.label ?? (item.labelKey | translate) }}
          </a>
          <span class="breadcrumb__sep" aria-hidden="true">/</span>
        } @else {
          <span class="breadcrumb__current" aria-current="page">{{ item.label ?? (item.labelKey | translate) }}</span>
        }
      </li>
    }
  </ol>
</nav>
